import React, { useEffect, useState } from "react";
import CardPartner from "../../../components/card/CardPartner";
import { useNavigate } from "react-router-dom";
import { partners } from "../../../models/mockdata";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

const Partner = () => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [filterBy, setFilterBy] = useState("title_all");

  useEffect(() => {
    const tempData = partners.filter(
      (partner) => filterBy === "title_all" || partner.type.includes(filterBy)
    );
    setData(tempData);
  }, [filterBy]);

  const initial = (type) => {
    if (type === "All") {
      return { opacity: 1, scale: 1, x: 100, y: 100 };
    } else if (type === "University") {
      return { opacity: 1, scale: 1, x: 100, y: 100 };
    } else return { opacity: 0, scale: 1, x: 0, y: 0 };
  };

  const animated = (type) => {
    if (type === "All") {
      return { opacity: 1, scale: 1, x: 0, y: 0 };
    } else if (type === "University") {
      return { opacity: 1, scale: 1, x: 0, y: 0 };
    } else return { opacity: 1, scale: 1, x: 0, y: 0 };
  };

  return (
    <div className="flex flex-col pt-[100px] px-[20px] sm:px-0 sm:mx-auto pb-[100px] max-w-[1140px] w-full sm:w-[85%] my-[50px] gap-0 sm:gap-[1.25rem] qhd:max-w-[60%]">
      <div className="px-[15px] mb-[100px]">
        <div className=" text-primary font-medium text-[2.65rem]  sm:text-[4.375rem]">
          {t("partners")}
        </div>
        <div className="flex flex-col md:flex-row">
          <div className="text-gray-500 mr-[14px] py-[7px] text-center font-semibold text-[0.875rem] sm:text-base w-fit pvmax:max-sm:hidden ">
            {t("filter_by")}
          </div>
          <div className="flex flex-row flex-wrap justify-center items-center w-fit gap-4">
            {[
              "All",
              "Real_Estate",
              "Tourism",
              "Financial_Services",
              "Logistics",
              "Other_Services",
            ].map((category) => (
              <div
                key={category}
                className={`text-[0.875rem] sm:text-base cursor-pointer ${
                  filterBy === `title_${category.toLowerCase()}`
                    ? "text-primary"
                    : "text-gray-500"
                }`}
                onClick={() => setFilterBy(`title_${category.toLowerCase()}`)}
              >
                {t(`title_${category.toLowerCase()}`)}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center flex-wrap">
        <AnimatePresence>
          {/* {data.map((partner, index) => (
            <motion.div
              key={partner.id || index} // Ensure each item has a unique key
              initial={initial(filterBy)}
              animate={animated(filterBy)}
              exit={{ opacity: 0, scale: 0 }}
              layout
              transition={{ duration: 0.25 }}
            >
              <CardPartner partner={partner} />
            </motion.div>
          ))} */}
          {data.length === 0 ? (
            <div>
              <p className="text-[4.375rem] text-[#6b7280]">
                {/* No matching result */}
              </p>
            </div> // Hiển thị thông báo khi data rỗng
          ) : (
            data.map((partner, index) => (
              <motion.div
                key={partner.id || index} // Đảm bảo mỗi item có key duy nhất
                initial={initial(filterBy)}
                animate={animated(filterBy)}
                exit={{ opacity: 0, scale: 0 }}
                layout
                transition={{ duration: 0.25 }}
              >
                <CardPartner partner={partner} />
              </motion.div>
            ))
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Partner;
